import addColorPicker from './colorpicker';
import addColumnsSelector from './columns-selector';
import addPresetComponentSelector from './preset-component-selector';
import addCtaButton from './cta-button';
import addFontSelector from './font-selector';
import addLinkWrapper from './link-wrapper';
import addList from './list';
import addIconButton from './icon-button';
import addInfoBox from './info-box';
import addInputField from './input-field';
import addTemplateNameInput from './template-name-input';
import addBorderSelector from './dropdown-selector'
import addModList from './mod-list';
import addSlider from './slider';
import addSocialLinks from './social-links';
import addStepButtons from './step-buttons';
import addStyleHeader from './style-header';
import addUploadButton from './upload-button';
import addToggleButton from './toggle-button';
import addToggleSwitch from './toggle-switch';
import addShortcutList from './shortcut-list';
import addAutoBranding from './auto-branding';
import addAiRewritePromptBox from './email-campaign-ai-content';
import addMergeTags from './merge-tags';
import type {PrimaryConfigOptions} from '../index';

/**
 * Custom type declarations for the StyleManager
 */

export default (opt: PrimaryConfigOptions): void => {
  addColorPicker(opt);
  addColumnsSelector(opt);
  addPresetComponentSelector(opt);
  addCtaButton(opt);
  addFontSelector(opt);
  addIconButton(opt);
  addInfoBox(opt);
  addInputField(opt);
  addTemplateNameInput(opt);
  addLinkWrapper(opt);
  addList(opt);
  addModList(opt);
  addSlider(opt);
  addSocialLinks(opt);
  addStepButtons(opt);
  addStyleHeader(opt);
  addUploadButton(opt);
  addToggleButton(opt);
  addToggleSwitch(opt);
  addShortcutList(opt);
  addAutoBranding(opt);
  void addAiRewritePromptBox(opt);
  addBorderSelector(opt);
  addMergeTags(opt);
};